/**
 * @file ServiceControlPanelPage.jsx
 * @description SERVICE department — Control Panel.
 *
 * The service pipeline dashboard (tiles, ring, weekly graph, breakdown map, error boxes, work list).
 *
 * This file belongs to the SERVICE department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for SERVICE is made HERE and can never leak into another
 * department's screens. The shared engine underneath (ServiceControlPanel) and the backend
 * stay common — only the department-facing page is departmental. Route access
 * is department-gated in utils/permissions.js: only SERVICE users (and the
 * super admin) can open it.
 */
import React from 'react';
import ServiceControlPanel from '../ServiceControlPanel';

const ServiceControlPanelPage = () => (<ServiceControlPanel />);

export default ServiceControlPanelPage;
